/* eslint-disable no-undef */

export const consoleErrorOnDev = (error) => {
  if (process.env?.NODE_ENV === 'development') {
    console.error(error);
  }
};
